import './packs/stripe_checkout'
import './controllers'
import Rails from '@rails/ujs'
Rails.start()
